// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import { ReportErrors } from '@jira/platform__error-reporting/src/ReportErrors.tsx';
import AppStyle from '@atlassian/jira-common-components-app-style/src/index.tsx';
import View from './ui/index.tsx';

export type AppProps = {
	onClick: ((e: Event) => void) | undefined;
};

const CreateButton = (props: AppProps) => (
	<ReportErrors id="unhandled" packageName="jiraCreateDashboardsButton" teamName="keystone">
		<AppStyle>
			<View onClick={props.onClick} />
		</AppStyle>
	</ReportErrors>
);

CreateButton.defaultProps = {
	onClick: undefined,
};

export default CreateButton;

export type CreateButtonProps = JSX.LibraryManagedAttributes<
	typeof CreateButton,
	ComponentProps<typeof CreateButton>
>;
